var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAlert = function SvgAlert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 8.00228C12.551 8.00228 12.999 8.44928 12.999 9.00228V13.0023C12.999 13.5543 12.551 14.0023 11.999 14.0023C11.446 14.0023 10.999 13.5543 10.999 13.0023V9.00228C10.999 8.44928 11.446 8.00228 11.999 8.00228Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 15.7523C12.689 15.7523 13.249 16.3123 13.249 17.0023C13.249 17.6923 12.689 18.2523 11.999 18.2523C11.309 18.2523 10.749 17.6923 10.749 17.0023C10.749 16.3123 11.309 15.7523 11.999 15.7523Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.00028C11.4979 2.00028 10.9959 2.25028 10.7169 2.75228L1.18695 19.8293C0.643947 20.8043 1.35195 22.0003 2.47095 22.0003H21.5299C22.6489 22.0003 23.3559 20.8043 22.8129 19.8293L13.2839 2.75228C13.0039 2.25028 12.5019 2.00028 11.9999 2.00028ZM11.9999 4.55428L20.6239 20.0083H3.37695L11.9999 4.55428Z",
    fill: "currentColor"
  })));
};
export default SvgAlert;